module.exports = __webpack_public_path__ + "static/media/path1.b1e01ebb.png";